import script from "./HistoryAddToCartConfirm2Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryAddToCartConfirm2Modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__